/* tslint:disable */
import {
  ProductionOrder,
  Product,
  ProductUom,
  ProductUomCategory,
  StockLocation,
  StockQuantPackage,
  StockProductionLot,
  Company,
  StockMove
} from '../index';

declare var Object: any;
export interface ProductionOrderInLineInterface {
  "id"?: number;
  "production_order_id"?: number;
  "product_id"?: number;
  "auto_assign_pack"?: boolean;
  "product_uom_id"?: number;
  "product_uom_category_id"?: number;
  "product_qty"?: number;
  "location_id"?: number;
  "package_id"?: number;
  "prod_lot_id"?: number;
  "company_id"?: number;
  "real_qty"?: number;
  "move_id"?: number;
  "date_done"?: Date;
  "state"?: string;
  productionOrder?: ProductionOrder;
  product?: Product;
  productUom?: ProductUom;
  productUomCategory?: ProductUomCategory;
  location?: StockLocation;
  package?: StockQuantPackage;
  prodLot?: StockProductionLot;
  company?: Company;
  move?: StockMove;
}

export class ProductionOrderInLine implements ProductionOrderInLineInterface {
  "id": number;
  "production_order_id": number;
  "product_id": number;
  "auto_assign_pack": boolean;
  "product_uom_id": number;
  "product_uom_category_id": number;
  "product_qty": number;
  "location_id": number;
  "package_id": number;
  "prod_lot_id": number;
  "company_id": number;
  "real_qty": number;
  "move_id": number;
  "date_done": Date;
  "state": string;
  productionOrder: ProductionOrder;
  product: Product;
  productUom: ProductUom;
  productUomCategory: ProductUomCategory;
  location: StockLocation;
  package: StockQuantPackage;
  prodLot: StockProductionLot;
  company: Company;
  move: StockMove;
  constructor(data?: ProductionOrderInLineInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ProductionOrderInLine`.
   */
  public static getModelName() {
    return "ProductionOrderInLine";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ProductionOrderInLine for dynamic purposes.
  **/
  public static factory(data: ProductionOrderInLineInterface): ProductionOrderInLine{
    return new ProductionOrderInLine(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ProductionOrderInLine',
      plural: 'ProductionOrderInLines',
      path: 'ProductionOrderInLines',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "production_order_id": {
          name: 'production_order_id',
          type: 'number'
        },
        "product_id": {
          name: 'product_id',
          type: 'number'
        },
        "auto_assign_pack": {
          name: 'auto_assign_pack',
          type: 'boolean'
        },
        "product_uom_id": {
          name: 'product_uom_id',
          type: 'number'
        },
        "product_uom_category_id": {
          name: 'product_uom_category_id',
          type: 'number'
        },
        "product_qty": {
          name: 'product_qty',
          type: 'number'
        },
        "location_id": {
          name: 'location_id',
          type: 'number'
        },
        "package_id": {
          name: 'package_id',
          type: 'number'
        },
        "prod_lot_id": {
          name: 'prod_lot_id',
          type: 'number'
        },
        "company_id": {
          name: 'company_id',
          type: 'number'
        },
        "real_qty": {
          name: 'real_qty',
          type: 'number'
        },
        "move_id": {
          name: 'move_id',
          type: 'number'
        },
        "date_done": {
          name: 'date_done',
          type: 'Date'
        },
        "state": {
          name: 'state',
          type: 'string'
        },
      },
      relations: {
        productionOrder: {
          name: 'productionOrder',
          type: 'ProductionOrder',
          model: 'ProductionOrder',
          relationType: 'belongsTo',
                  keyFrom: 'production_order_id',
          keyTo: 'id'
        },
        product: {
          name: 'product',
          type: 'Product',
          model: 'Product',
          relationType: 'belongsTo',
                  keyFrom: 'product_id',
          keyTo: 'id'
        },
        productUom: {
          name: 'productUom',
          type: 'ProductUom',
          model: 'ProductUom',
          relationType: 'belongsTo',
                  keyFrom: 'product_uom_id',
          keyTo: 'id'
        },
        productUomCategory: {
          name: 'productUomCategory',
          type: 'ProductUomCategory',
          model: 'ProductUomCategory',
          relationType: 'belongsTo',
                  keyFrom: 'product_uom_category_id',
          keyTo: 'id'
        },
        location: {
          name: 'location',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'location_id',
          keyTo: 'id'
        },
        package: {
          name: 'package',
          type: 'StockQuantPackage',
          model: 'StockQuantPackage',
          relationType: 'belongsTo',
                  keyFrom: 'package_id',
          keyTo: 'id'
        },
        prodLot: {
          name: 'prodLot',
          type: 'StockProductionLot',
          model: 'StockProductionLot',
          relationType: 'belongsTo',
                  keyFrom: 'prod_lot_id',
          keyTo: 'id'
        },
        company: {
          name: 'company',
          type: 'Company',
          model: 'Company',
          relationType: 'belongsTo',
                  keyFrom: 'company_id',
          keyTo: 'id'
        },
        move: {
          name: 'move',
          type: 'StockMove',
          model: 'StockMove',
          relationType: 'belongsTo',
                  keyFrom: 'move_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ProductionOrderInLine.ts